export const MAX_NUMBER_OF_NEW_DEVICES = 200;
export const NOTIFICATION_DISPLAY_TIME = 10000;

// max 7 characters
export const MAX_NUMBER_CHARACTERS = 9999999;
export const MAX_NUMBER_CHARACTERS_QUANTITY_OF_PAYMENTS = 100;
export const MIN_NUMBER_CHARACTERS_QUANTITY_OF_PAYMENTS = 0;

export const MAX_LICENSE_QUANTITY = 1000;

export const MOBILE_DEVICE_STATE_NAMES = ['inUse', 'onStock', 'underRepair'];
export const MOBILE_DEVICE_NON_IN_USE_STATE_NAMES = ['onStock', 'underRepair'];
export const MOBILE_DEVICE_STATE_ON_STOCK_NAME = ['onStock'];
export const DEVICE_STATE_NAMES = ['inUse', 'onStock', 'underRepair', 'ordered', 'writeOff'];
export const DEVICE_NON_ORDERED_STATE_NAMES = ['inUse', 'onStock', 'underRepair', 'writeOff'];
export const DEVICE_NON_IN_USE_STATE_NAMES = ['onStock', 'underRepair', 'ordered', 'writeOff'];
export const STATES_FOR_CREATE_NAMES = ['onStock', 'ordered'];
export const STATES_FOR_ASSIGN_DEVICE_NAMES = ['inUse', 'inTransitToUser'];
export const STATES_FOR_EDIT_DEVICE_NAMES = ['inUse', 'inTransitToStock'];
export const STATES_FOR_EDIT_STATES_NON_IN_USE_NAMES = ['onStock', 'underRepair', 'writeOff'];
export const STATES_FOR_EDIT_STATES_WITH_IN_OFFICE_NAMES = ['inOffice', 'onStock', 'underRepair', 'writeOff'];
export const STATES_FOR_EDIT_STATES_IN_OFFICE_NAMES = ['inOffice', 'onStock'];

export const CLIENT_ID = '388198302053-240538aeiuu1vq7k4ajaodckm44h4qj7.apps.googleusercontent.com';
export const DEVELOPER_KEY = 'AIzaSyCPhtU686nqBx3XBeX7eEF8qmaRS9QGUmE';

export const COLORS = Object.freeze({
    primary: {
        main: '#023047'
    },
    secondary: {
        main: '#80C6B5'
    },
    accent: {
        main: '#209EBC',
        second: '#76E5CF',
        third: '#8ECAE6'
    },
    error: {
        main: '#f24747',
        dark: '#D50000'
    },
    lightRedColor: '#e57373',
    redColor: '#df5151',
    darkGrayColor: '#bebebe',
    darkColor: '#000000DE',
    darkGreyColor: '#0000008a',
    greenColor: '#00c853',
    whiteGreyColor: '#fafafa',
    popoverColor: '#424242',
    whiteBlueColor: '#80C6B5',
    disabled: {
        backgroundColor: '#fafafa',
        color: '#c8c8c8'

    }
});

export const KEY_CODES = {
    Enter: 13
};

export const OLD_HISTORY_DATE = {
    devices: '2021-01-17T00:00:00',
    mobileDevices: '2021-01-18T00:00:00',
    licenses: '2021-01-18T00:00:00'
};

export const DEVICE_FILTER_FIELD_INIT = {
    searchData: ['searchData'],
    conditionFilter: ['condition', 'state', 'primary', 'isReserved'],
    dateFilter: ['assignmentDateFrom', 'assignmentDateTo', 'deliveryDateFrom', 'deliveryDateTo'],
    deviceFilter: ['ids', 'deviceTypes', 'deviceManufacturers', 'infrastructureUnit'],
    deviceSpecificationFilter: ['oSTypes', 'processorNameTypes', 'fromCoreCountTypes', 'toCoreCountTypes', 'fromDiskSizeTypes', 'toDiskSizeTypes', 'fromRamSizeTypes', 'toRamSizeTypes', 'fromRamSlotTypes', 'toRamSlotTypes', 'isInEndpointCentral'],
    locationFilter: ['offices', 'resourceOwner'],
    userFilter: ['users',
        'positionsInCompany',
        'roleOnProject',
        'projectsInCompany',
        'primarySkill'],
    leasedDeviceFilter: ['leasingContract', 'LeasingContractIds', 'LeasingContractEndDateFrom', 'LeasingContractEndDateTo'],
};

export const MOBILE_DEVICE_FILTER_FIELD_INIT = {
    searchData: ['searchData'],
    conditionFilter: ['condition', 'state'],
    dateFilter: ['assignmentDateFrom', 'assignmentDateTo', 'deliveryDateFrom', 'deliveryDateTo'],
    mobileDeviceFilter: ['ids', 'deviceTypes', 'osVersions', 'screens'],
    locationFilter: ['offices', 'resourceOwner'],
    userFilter: ['users', 'projects', 'primarySkill'],
};

export const LICENSE_FILTER_FIELD_INIT = [
    'searchData',
    'licensingType',
    'licenseTitles',
    'licenseManufacturers',
    'licenseType',
    'locations',
    'resourceOwner',
    'deliveryDateFrom',
    'deliveryDateTo',
    'expirationDateFrom',
    'expirationDateTo',
    'users',
    'isOrdered'
];

export const VM_FILTER_FIELD_INIT = [
    'locations',
    'virtualMachines',
];

export const LICENSING_TYPE = {
    perpetual: 'perpetual',
    subscription: 'subscription',
    allLicenses: 'all'
};

export const PAYMENTS_ITEM = {
    date: 'PaymentDate',
    amount: 'PaymentAmount',
    comments: 'Comments'
};

export const PAYMENTS_TYPE = {
    schedule: 'schedule',
    actual: 'actual',
};

export const LICENSES_TYPES_ID = {
    user: 1,
    infrastructureUnit: 2,
    company: 3,
    vm: 4
};

export const LICENSES_TYPES = {
    1: 'user',
    2: 'infrastructureUnit',
    3: 'company',
    4: 'virtualMachine'
};

export const REPORTS = {
    eisEcCompareDevice: 'ecCompareDevice'
};

export const LICENSE_STATE_ID = {
    writeOff: 3,
    invalid: 4,
};

export const USER_STATUSES = {
    employees: ['Active', 'Future', 'Inactive', 'Returning'],
    notEmployees: ['NotEmployed'],
    all: ['Active', 'Future', 'Inactive', 'Returning', 'NotEmployed']
};

export const LOCATION_STATES_ID = {
    all: {
        id: 1,
        name: 'all',
        alternativeName: 'All',
        boolState: true
    },
    onlyActive: {
        id: 2,
        name: 'onlyActive',
        alternativeName: 'OnlyActive',
        boolState: false
    },
};

export const LOCATION_STATES = {
    all: 1,
    onlyActive: 2,
};
export const EQUIPMENT = {
    license: 'licenses',
    device: 'devices',
    reservedDevices: 'reservedDevices',
    mobileDevice: 'mobileDevices',
};
